import { render, staticRenderFns } from "./historyOrderList.vue?vue&type=template&id=15bfbb3e&scoped=true&"
import script from "./historyOrderList.vue?vue&type=script&lang=js&"
export * from "./historyOrderList.vue?vue&type=script&lang=js&"
import style0 from "./historyOrderList.vue?vue&type=style&index=0&id=15bfbb3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bfbb3e",
  null
  
)

export default component.exports